import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Alert } from '@mui/material';
const ErrorAlert = ({ error }) => {
    // Ensure the error is a string before rendering
    const errorMessage = typeof error === 'string' ? error : "An unknown error occurred.";
    return (_jsx(Alert, { severity: "error", children: errorMessage }));
};
export default ErrorAlert;
